import { Button, Modal, Popover, Radio } from 'antd'
import './index.less'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getNativeTokenInfo } from "@/request/native";
import { getSymbol } from '@/config/symbol'
import { NET_ID, NET_NAME } from '@/config'
import { setChainModalOpen } from "@/stores/reducers/common";
import { cdnUrl } from '@/utils/cdn';
import MyIcon from '@/router/Icon'
import { FuPrivider } from '@/provider/FuProvider'




const nativeCoin = getNativeTokenInfo();
// console.log("nativeCoin", nativeCoin);

function PopTips({ onClose }: any) {
  const { t, i18n } = useTranslation();
  return (<div className='pop-tips-content'>
    <div className='pop-tips-main'>
      <img src={cdnUrl("/img/tips.svg")} alt="" />
      <p>{t("tips.tronTonToolsAdded")}</p>
    </div>
    <div className='pop-tips-footer'>
      <Button type="primary" onClick={onClose}>{t("FreezeTokenAccount.ok")}</Button>
    </div>
  </div>)
}
export default function NetWorkButton() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const isRun = window.localStorage.getItem("netTips")
  const [run, setRun] = useState(!isRun);
  const [price, setPrice] = useState(0)
  // const [feeType, setFeeType] = useState<any>(1)
  const { feeType, fees } = useSelector((state: any) => {
    return state.projectControll
  })
  // 网络配置
  const NETWORK_CONFIG = [
    {
      // id: 56,
      name: 'SUI Mainnet',
      url: `https://slerf.tools/${i18n.language}/sui`,//'https://bsc.slerf.tools',
      icon: cdnUrl('/img/sui/sui.png')
    },
    {
      id: 8453,
      name: 'BASE',
      url: `https://base.slerf.tools/${i18n.language}`,
      icon: cdnUrl('/img/chains/base.webp')
    },
    {
      id: 1,
      name: 'ETH',
      url: `https://eth.slerf.tools/${i18n.language}`,
      icon: cdnUrl('/img/chains/eth.svg')
    },
    {
      id: 196,
      name: 'X Layer',
      url: `https://slerf.tools/${i18n.language}/x-layer`,
      icon: cdnUrl('/img/chains/xlayer.svg')
    }
  ];
  const {
    isM, is1920, is1440, is1200, is750
  } = useSelector((state: any) => {
    return state.device
  })

  const [open, setOpen] = useState(false)
  const [openPop, setOpenPop] = useState(false)

  function showModal() {
    setOpen(true)
  }

  function hideModal() {
    setOpen(false)
  }


  function hidePop() {
    setOpenPop(false)
  }

  const handleOpenChange = (newOpen: boolean) => {
    setOpenPop(newOpen);
  };

  const handlePopTips = () => {
    window.localStorage.setItem('netTips', "1")
    setRun(false)
  }


  // 网络列表项组件
  const NetworkItem = ({ network }: { network: typeof NETWORK_CONFIG[0] }) => (
    <a className="nets-list-item" href={network.url} target="_blank" rel="noopener noreferrer">
      <img src={network.icon} className="ico" alt={network.name} />
      <span>{network.name}</span>
      <img src={cdnUrl("/img/share.svg")} className="share" alt="share" />
    </a>
  );

  // 渲染网络列表
  const NetworkList = ({ currentNetId }: { currentNetId: number }) => (
    <>
      {NETWORK_CONFIG.map(network =>
        network.id !== currentNetId && (
          <NetworkItem
            key={network.id}
            network={network}
          />
        )
      )}
    </>
  );

  const content = <div className='nets'>
    <div className='nets-list'>
      <a className="nets-list-item" href={`https://slerf.tools/${i18n.language}`} target='_blank'>
        <img src={cdnUrl("/img/sol.svg")} className='ico' alt="" />
        <span>Solana</span>
        <img src="/img/share.svg" className='share' alt="" />
      </a>
      <NetworkList currentNetId={NET_ID} />
      <a className="nets-list-item" href={`https://tron.slerf.tools/${i18n.language}`} target='_blank'>
        <img src="/img/tron.svg" className='ico' alt="" />
        <span>TRON</span>
        <img src="/img/share.svg" className='share' alt="" />
      </a>
      <a className="nets-list-item" href={`https://ton.slerf.tools/${i18n.language}`} target='_blank'>
        <img src="/img/ton.svg" className='ico' alt="" />
        <span>TON</span>
        <img src="/img/share.svg" className='share' alt="" />
      </a>

    </div>
  </div>


  async function loadPrice() {
    try {
      setPrice(0)
    } catch (error) {
      setPrice(0)
    }
  }

  useEffect(() => {
    loadPrice()
  }, [])

  // if (isM || is750) {
  //   return (
  //     <>
  //       <div className='network-button'>
  //         <button onClick={showModal}>
  //           <img src={cdnUrl("/img/sol.png")} alt=""/>
  //         </button>
  //       </div>
  //       <Modal
  //       wrapClassName="fee-modal"
  //       title={ null }
  //       centered
  //       footer={null}
  //       open={open}
  //       onOk={() => hideModal()}
  //       onCancel={() => hideModal()}
  //       width={300}
  //     >
  //       {
  //         content
  //       }
  //     </Modal>
  //     </>
  //   )
  // }

  return (
    <>

      <div className='network-button my-first-step'>

        {/* <button className={openPop ? 'active' : ''} onClick={() => {
          dispatch(setChainModalOpen({ type: "website", visible: true }));
        }}>
       
          <MyIcon type='icon-a-sui1' style={{ marginRight: 8, fontSize: 20 }}></MyIcon>
          <span>SUI</span>
          <strong>
            <img src={cdnUrl("/img/eth/up-outlined.webp")} />
          </strong>
        </button> */}
        <FuPrivider></FuPrivider>

      </div>
    </>
  )
}